import gql from 'graphql-tag';

export const GET_USER_STATISTICS_QUERY = gql`
  query GetUserStatistics($from: DateTime, $to: DateTime) {
    getUserStatistics(from: $from, to: $to) {
      femaleUsers
      maleUsers
      totalReferrals
      totalUsers
      totalUsersDeleted
    }
  }
`;
